<template>
  <div class="appointment-home">
    <div class="appointment-home-header">
      <van-tabs
        type="card"
        v-model="activeTab"
        @change="tabChange"
      >
        <van-tab
          title="专家预约"
          :name="keyMap.appointment"
        > </van-tab>
        <van-tab
          title="我要分诊"
          :name="keyMap.triage"
        ></van-tab>
      </van-tabs>
      <van-search
        v-show="activeTab == keyMap.appointment"
        v-model="appointmentInfor.filter"
        show-action
        label=""
        maxlength="20"
        placeholder="请输入医生、科室、医院、疾病"
        @search="onSearch"
        @input="clearSearch"
      >
        <template #action>
          <div @click="onSearch">搜索</div>
        </template>
      </van-search>
      <!-- <van-search
        v-show="activeTab == keyMap.triage"
        v-model="triageInfor.filter"
        show-action
        label=""
        placeholder="请输入医生、科室、医院"
        @search="onSearch">
        <template #action>
          <div @click="onSearch">搜索</div>
        </template>
      </van-search> -->
    </div>

    <div
      class="appointment-home-expert"
      v-show="activeTab == keyMap.appointment && !appointmentInfor.isSearch"
    >
      <van-tree-select
        height="55vw"
        :items="items"
        :main-active-index.sync="active"
        @click-nav="clickNav"
      >
        <template #content>
          <template v-if="active === 0">
            <div
              v-for="(department, index) in departmentList"
              :key="index"
              class="van-ellipsis van-tree-select__item"
              @click="onDepartmentClick(department)"
            >
              {{ department.value }}
            </div>
          </template>
          <template v-if="active === 2">
            <div
              v-for="(disease, index) in diseaseList"
              :key="index"
              class="van-ellipsis van-tree-select__item"
              @click="onDiseaseClick(disease)"
            >
              {{ disease.value }}
            </div>
          </template>
          <div v-if="active === 1">
            <div
              class="appointment-doctor"
              v-for="doctor in appointmentInfor.allDcotorList"
              :key="doctor.id"
            >
              <div class="appointment-doctor-top">
                <div class="appointment-doctor-top-left">
                  <div class="appointment-doctor-top-left-avatar">
                    <img
                      :src="
                        doctor.img_head
                          ? `data:image/jpeg;base64,${doctor.img_head}`
                          : doctor.sex_str === keyMap.sexMan
                          ? man
                          : female
                      "
                      alt=""
                    />
                  </div>
                  <div class="appointment-doctor-top-left-info">
                    <div class="appointment-doctor-top-left-info-name">
                      <strong>
                        {{ doctor.name }}
                        <img
                          v-if="doctor.feature_profession"
                          src="@/assets/images/huangguan.png"
                          alt=""
                        >
                      </strong>
                      <span></span>
                    </div>
                    <div class="appointment-doctor-top-left-info-name">
                      <span>{{ doctor.hospital_name }}-{{ doctor.department }} - {{ doctor.title }}</span>
                    </div>
                    <div
                      class="appointment-doctor-top-left-info-name"
                      v-if="doctor.diagnose_time"
                    >
                      <span>看诊时长：{{ doctor.diagnose_time }}分钟</span>
                    </div>
                    <div class="appointment-doctor-top-left-info-name appointment-doctor-top-left-info-rate">
                      <span>
                        预约时效：<van-rate
                          color="rgb(252, 93, 87)"
                          :value="doctor.ageing"
                        />
                      </span>
                    </div>

                    <div class="appointment-doctor-top-left-info-appointment">
                      <span v-if="doctor.diagnose_location"> {{ doctor.diagnose_location }}门诊部 </span>
                      <span>{{ doctor.online_type_names }}</span>
                      <el-button
                        @click="doctorSelect(doctor)"
                        :type="
                          +doctor.booking_mode === 1 ? 'primary' : 'warning'
                        "
                        size="mini"
                      >
                        {{ +doctor.booking_mode === 1 ? "预约" : "意向" }}
                      </el-button>
                    </div>
                  </div>
                </div>
                <div class="appointment-doctor-top-right"></div>
              </div>
              <div class="appointment-doctor-bottom">
                <p>
                  <span v-if="doctor.language">{{ doctor.language }}</span>
                  <span>看诊费：{{ +doctor.price === 0 ? "" : doctor.price }}</span>
                </p>
                <p v-if="doctor.fee_remark">
                  <span>看诊费备注：{{ doctor.fee_remark }}</span>
                </p>
                <p
                  class="appointment-doctor-bottom"
                  v-if="doctor.disease"
                >
                  擅长专病：{{ doctor.disease }}
                </p>
                <p
                  class="appointment-doctor-bottom"
                  v-if="doctor.good_at"
                >
                  擅长：{{ doctor.good_at }}
                </p>
                <p
                  class="appointment-doctor-bottom"
                  v-if="doctor.feature_profession_desc"
                >
                  特色专科：{{ doctor.feature_profession_desc }}
                </p>
                <!-- <p>
                  {{ doctor.good_at }}
                </p> -->
              </div>
            </div>
          </div>
        </template>
      </van-tree-select>
    </div>
    <div
      class="doctor-box"
      v-if="activeTab == keyMap.appointment && appointmentInfor.isSearch"
    >
      <h3 class="appointment-home-search-title">为您找到以下医生信息</h3>
      <doctor
        v-for="doctor in appointmentInfor.searchDoctorList"
        :doctor="doctor"
        :key="doctor.id"
        :type="activeTab"
        @select="doctorSelect"
      />
    </div>
    <!-- <div class="triage-doctor-box" v-show="activeTab == keyMap.triage">
      <div v-if="!triageInfor.isSearch">
        <doctor
          v-for="doctor in triageInfor.allDcotorList"
          :doctor="doctor"
          :key="doctor.id"
          :type="activeTab"
          :intentionDoctorList="triageInfor.intentionDoctorList"
          @select="doctorSelect" />
      </div>
      <div v-else>
        <doctor
          v-for="doctor in triageInfor.searchDoctorList"
          :doctor="doctor"
          :key="doctor.id"
          :type="activeTab"
          :intentionDoctorList="triageInfor.intentionDoctorList"
          @select="doctorSelect" />
      </div>
    </div> -->

    <!-- <div
      class="appointment-home-triage-footer"
      v-show="activeTab == keyMap.triage">
      <div
        class="appointment-home-triage-footer-left"
        @click="$refs.triagePopup.open()">
        <van-icon name="friends-o" size="24px" />确认选择以上{{
          triageInfor.intentionDoctorList.length
        }}位医生
      </div>
      <div class="appointment-home-triage-footer-right">
        <el-button type="primary" size="mini" @click="triagePatient"
          >去分诊</el-button
        >
      </div>
    </div> -->
    <!-- <triagePopup
      ref="triagePopup"
      :doctorList="triageInfor.intentionDoctorList"
      :intentionDoctorList="triageInfor.intentionDoctorList"
      @cancel="cancelSelect" /> -->
    <div
      v-show="!appointmentInfor.isSearch"
      class="appointment-home-history"
      @click="goPage('AppointmentHistory')"
    >
      预约<br />
      历史
    </div>
  </div>
</template>

<script>
import doctor from "./components/doctor.vue";
// import triagePopup from "./components/triagePopup.vue";
import bookingDiagnoseService from "@/apis/bookingDiagnose/index.js";
import keyMap from "@/constants/appointment.js";
import man from "@/assets/images/user_head_man.png";
import female from "@/assets/images/user_head_female.png";
let originDiseaseList = [];

export default {
  components: {
    doctor,
    // triagePopup,
  },
  data() {
    return {
      man,
      female,
      keyMap,
      appointmentInfor: {
        allDcotorList: [],
        searchDoctorList: [],
        isSearch: false,
        filter: "",
      },
      triageInfor: {
        allDcotorList: [],
        searchDoctorList: [],
        intentionDoctorList: [],
        isSearch: false,
        filter: "",
      },
      triageShow: true,
      activeTab: 1,
      value: "",
      active: 0,
      departmentList: [],
      diseaseList: [],
      appointmentDoctorList: [],
      items: [
        {
          text: "科室",
          children: [],
        },
        { text: "医生" },
        {
          text: "疾病",
          children: [],
        },
      ],
    };
  },
  created() {
    this.getDoctorList();
    this.getDepartmentList();
    this.getBookingDiagnoseRetrievalList();
  },

  methods: {
    // 去分诊
    triagePatient() {
      // 校验至少选择一个医生
      const { activeTab } = this;
      const { intentionDoctorList } = this.triageInfor;
      if (intentionDoctorList.length === 0) {
        this.$toast("请至少选择一个医生");
        return;
      }
      this.$router.push({
        name: "AppointmentConfirm",
        query: {
          doctorId: intentionDoctorList.map((item) => item.id).join(","),
          type: activeTab,
        },
      });
    },
    cancelSelect(doctor) {
      const { intentionDoctorList } = this.triageInfor;
      const index = intentionDoctorList.findIndex(
        (item) => item.id === doctor.id
      );
      intentionDoctorList.splice(index, 1);
    },
    doctorSelect(doctor) {
      const { activeTab } = this;
      this.$router.push({
        name: "AppointmentConfirm",
        query: {
          doctorId: doctor.id,
          type: activeTab,
          mode: doctor.booking_mode,
          duid: this.$route.query.duid || undefined,
          mobile: this.$route.query.mobile || undefined,
        },
      });
    },
    onDepartmentClick(item) {
      this.$router.push({
        name: "AppointmentDoctor",
        query: {
          departmentId: item.key,
          duid: this.$route.query.duid || undefined,
          mobile: this.$route.query.mobile || undefined,
        },
      });
    },
    tabChange(name) {
      if (name === keyMap.triage) {
        this.$router.push({
          name: "AppointmentConfirm",
          query: {
            type: name,
            mode: 3,
            duid: this.$route.query.duid || undefined,
          },
        });
        this.activeTab = keyMap.appointment;
      } else {
        this.getDoctorList();
      }
    },
    getDoctorList({ departmentId = null } = {}) {
      const { activeTab, appointmentInfor, triageInfor } = this;
      const loading = this.$loading({
        lock: true,
        text: "加载中，请稍等...",
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 0.7)",
      });
      const params = {
        booking_type: this.activeTab,
        filter:
          activeTab == keyMap.appointment
            ? appointmentInfor.filter
            : triageInfor.filter,
        department_id: departmentId ? Number(departmentId) : null,
      };
      bookingDiagnoseService.doctorList(params).then((res) => {
        if (activeTab === keyMap.appointment) {
          if (departmentId !== null) {
            appointmentInfor.allDcotorList = res;
            this.active = 1;
          } else if (appointmentInfor.isSearch) {
            appointmentInfor.searchDoctorList = res;
          } else {
            appointmentInfor.allDcotorList = res;
          }
        } else {
          if (triageInfor.isSearch) {
            triageInfor.searchDoctorList = res;
          } else {
            triageInfor.allDcotorList = res;
          }
        }
        loading.close();
      });
    },
    getDepartmentList() {
      const params = {
        filter: "",
      };
      bookingDiagnoseService.departmentList(params).then((res) => {
        res.unshift({
          key: "",
          value: "全部",
        });
        this.departmentList = res;
      });
    },
    getBookingDiagnoseRetrievalList() {
      const params = {
        filter: "",
      };
      bookingDiagnoseService
        .bookingDiagnoseRetrievalList(params)
        .then((res) => {
          originDiseaseList = res.disease_list;
          originDiseaseList.forEach((disease) => {
            disease.value = disease.disease_name;
            disease.children = disease.hospital_list;
            disease.children.forEach((hospital) => {
              hospital.value = hospital.hospital_name;
              hospital.children = hospital.department_list;
              hospital.children.forEach((department) => {
                department.value = department.department_name;
              });
              hospital.children.unshift({
                key: "",
                value: "全部",
              });
            });
            disease.children.unshift({
              key: "",
              value: "全部",
            });
          });
          originDiseaseList.unshift({
            key: "",
            value: "全部",
          });
          console.log(res);

          this.diseaseList = originDiseaseList;
        });
    },
    onDiseaseClick(item) {
      if (item.doctor_ids || item.value === "全部") {
        this.$router.push({
          name: "AppointmentDoctor",
          query: {
            doctorIds: item.doctor_ids || undefined,
            duid: this.$route.query.duid || undefined,
            mobile: this.$route.query.mobile || undefined,
          },
        });
      } else {
        this.diseaseList = item.children;
      }
    },
    clickNav() {
      this.diseaseList = originDiseaseList;
    },
    onSearch() {
      const { activeTab } = this;
      if (activeTab === keyMap.appointment) {
        this.appointmentInfor.isSearch = true;
      } else {
        this.triageInfor.isSearch = true;
      }

      this.getDoctorList();
    },
    clearSearch(value) {
      if (value != "") return;
      this.appointmentInfor.isSearch = false;
    },
    // 页面跳转
    goPage(pageName) {
      this.$router.push({
        name: pageName,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.appointment-home {
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  v-deep .van-tabs__nav--card {
    margin: 0;
  }
  .appointment-home-header {
    flex-shrink: 0;
  }
  .appointment-home-expert {
    flex: 1;
    overflow: auto;
  }
  .van-tree-select {
    height: 100% !important;
  }
}
.appointment-doctor {
  padding: 10px 10px;
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid #eee;

  strong,
  span {
    margin-right: 15px;
    margin-bottom: 7px;
    display: flex;
    align-items: center;
  }
  .appointment-doctor-top {
    display: flex;
    flex-direction: row;
    align-items: center;
    .appointment-doctor-top-left {
      display: flex;
      flex-direction: row;
      flex: 1;
      align-items: center;
      width: 100%;
      .appointment-doctor-top-left-avatar {
        width: 50px;
        height: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 15px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .appointment-doctor-top-left-info {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        flex: 1;
        .appointment-doctor-top-left-info-name {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          width: 100%;
          span {
            font-size: 12px;
            color: #333;
            margin-right: 0;
          }
          strong {
            margin-right: 0;
          }
          img {
            width: 16px;
          }
        }
        .appointment-doctor-top-left-info-rate {
          justify-content: flex-start;
          align-items: center;
        }
        .appointment-doctor-top-left-info-hospital {
          width: 100%;
          height: 30%;
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          align-items: center;
          span {
            font-size: 0.8rem;
            color: #333;
            margin-right: 0.5rem;
          }
        }
        .appointment-doctor-top-left-info-appointment {
          width: 100%;
          height: 30%;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          span {
            font-size: 0.8rem;
            color: #333;
            margin-right: 0.5rem;
          }
        }
      }
    }
    .appointment-doctor-top-right {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .appointment-doctor-bottom {
    display: flex;
    flex-direction: column;
    font-size: 12px;
    color: #333;
    p {
      margin: 0;
    }
  }
}
.appointment-home-search-title {
  font-size: 14px;
  border-bottom: 1px solid #eee;
  padding: 10px 10px;
}
.appointment-home-triage-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: absolute;
  bottom: 0px;
  width: 100%;
  box-sizing: border-box;
  color: red;
  padding: 10px 10px;
  padding-bottom: 30px;
  border-bottom: 1px solid #eee;
  z-index: 9999;
  background-color: #fff;
  .appointment-home-triage-footer-left {
    display: flex;
    align-items: center;
    .van-icon {
      margin-right: 5px;
    }
  }
}
.appointment-home-history {
  position: absolute;
  top: 60vh;
  left: 5px;
  border: 2px solid #409eff;
  color: #409eff;
  display: flex;
  width: 50px;
  height: 50px;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
}
.triage-doctor-box {
  flex: 1;
  overflow: auto;
  padding-bottom: 100px;
}
.doctor-box {
  flex: 1;
  overflow-y: auto;
}
</style>
<style lang="scss">
.appointment-home {
  .van-tabs__nav--card {
    margin: 0;
  }
  .van-tree-select__content {
    flex: 3;
  }
}
</style>
